import React, { useState, useEffect, forwardRef } from "react";
import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";
import { Dropdown } from "primereact/dropdown";
import {
  CombineDateTime,
  ToFormatedHour,
  ToFormatedISOTime,
  ToFormatedShortISODate,
} from "../../../../utils/dates";
import teachersAPI from "../../../../services/teachers";
import classroomsAPI from "../../../../services/classrooms";
import MeaUpdateModal from "../../../../components/MeaUpdateModal";
import sessionsAPI from "../../../../services/sessions";
import { Calendar } from "primereact/calendar";
import { useParams } from "react-router-dom";

const UpdateSessionModal = forwardRef((props, ref) => {
  const params = useParams();
  const schoolId = params.schoolId
  const trainingId = params.trainingId;
  const accessToken = "";
  //const timezone = authContext?.currentMembership?.school?.timezone;
  const timezone = "Europe/Paris";
  //
  const [teacher, setTeacher] = useState("-1");
  const [classroom, setClassroom] = useState("-1");
  const [day, setDay] = useState("");
  const [startHour, setStartHour] = useState("");
  const [endHour, setEndHour] = useState("");
  const [points, setPoints] = useState(0);
  //
  useEffect(() => {
    setTeacher(props?.session?.teacher_id || "-1");
    setClassroom(props?.session?.classroom_id || "-1");
    setDay(props?.session?.event?.start_date ? new Date(props?.session?.event?.start_date) : null);
    setStartHour(ToFormatedHour(new Date(props?.session?.event?.start_date)));
    setEndHour(ToFormatedHour(new Date(props?.session?.event?.end_date)));
    setPoints(props?.session?.points ?? 0);
  }, [props]);
  //
  const teachersList = teachersAPI.useGetList(
    schoolId,
    trainingId,
    accessToken,
    1,
    100000
  );
  const uniqueTeachers = teachersList.data?.data || [];
  uniqueTeachers.sort((a, b) => a.member.lastname - b.member.lastname);
  const teachers = uniqueTeachers.map((teacher, index) => ({
    key: teacher.id,
    label: teacher.member?.name ? teacher.member?.name : teacher.member.lastname + " " + teacher.member.firstname,
    value: teacher.id,
  }));
  teachers.unshift({
    key: "empty-teacher-key",
    label: "",
    value: "",
  });
  //
  const classroomsList = classroomsAPI.useGetList(
    schoolId,
    trainingId,
    accessToken,
    1,
    100000
  );
  const uniqueClassrooms = classroomsList.data?.data || [];
  uniqueClassrooms.sort((a, b) => a.name - b.name);
  const classrooms = uniqueClassrooms.map((classroom, index) => ({
    key: classroom.id,
    label: classroom.name,
    value: classroom.id,
  }));
  classrooms.unshift({
    key: "empty-classroom-key",
    label: "",
    value: "",
  });
  //
  return (
    <>
      <MeaUpdateModal
        ref={ref}
        title="Editer la session"
        schoolId={schoolId}
        trainingId={trainingId}
        serviceAPI={sessionsAPI}
        dialogStyle={{ width: "45vw" }}
        id={props?.session?.id}
        data={{
          teacher_id: teacher === "-1" ? "" : teacher,
          classroom_id: classroom === "-1" ? "" : classroom,
          start_date: CombineDateTime(day, startHour, timezone),
          end_date: CombineDateTime(day, endHour, timezone),
          points: points ?? 0,
        }}
      >
        <label htmlFor="jour" className="font-medium text-900">Jour</label>
        <Calendar locale="fr" value={day ? new Date(day) : null} onChange={(e) => setDay(e.value)} dateFormat="dd/mm/yy" id="jour" showIcon />

        <div className="card flex flex-column md:flex-row gap-3">
          <div className="p-inputgroup flex flex-column gap-2">
            <label
              htmlFor="heureDebut"
              className="block text-900 font-medium mb-2"
            >
              Heure de début
            </label>
            <InputText
              id="heureDebut"
              type="time"
              value={startHour}
              onChange={(e) => setStartHour(e.target.value)}
              className="w-full mb-3"
            />
          </div>
          <div className="p-inputgroup flex flex-column gap-2">
            <label
              htmlFor="heureFin"
              className="block text-900 font-medium mb-2"
            >
              Heure de fin
            </label>
            <InputText
              id="heureFin"
              type="time"
              value={endHour}
              onChange={(e) => setEndHour(e.target.value)}
              className="w-full mb-3"
            />
          </div>
        </div>
        <small>
          Les heures doivent correspondre au fuseau horaire de l'école (
          {timezone})
        </small>

        <div className="card flex flex-column md:flex-row gap-3">
          <div className="p-inputgroup flex flex-column gap-2">
            <label htmlFor="classe" className="block text-900 font-medium mb-2">
              Classe
            </label>
            <InputText
              id="classe"
              value={props?.session?.schedule_item?.classe?.name}
              className="w-full mb-3"
              disabled={true}
            />
          </div>
          <div className="p-inputgroup flex flex-column gap-2">
            <label htmlFor="cours" className="block text-900 font-medium mb-2">
              Matière
            </label>
            <InputText
              id="cours"
              value={props?.session?.schedule_item?.course?.name}
              className="w-full mb-3"
              disabled={true}
            />
          </div>
        </div>

        <div className="card flex flex-column md:flex-row gap-3">
          <div className="p-inputgroup flex flex-column gap-2">
            <label
              htmlFor="enseignant"
              className="block text-900 font-medium mb-2"
            >
              Enseignant(e)
            </label>
            <Dropdown
              id="enseignant"
              options={teachers}
              value={teacher || "-1"}
              onChange={(e) => setTeacher(e.value)}
              optionLabel="label"
              placeholder="Choisir un(e) Enseignant(e)"
              className="w-full mb-3"
            />
          </div>
          <div className="p-inputgroup flex flex-column gap-2">
            <label htmlFor="salle" className="block text-900 font-medium mb-2">
              Salle
            </label>
            <Dropdown
              id="salle"
              options={classrooms}
              value={classroom || "-1"}
              onChange={(e) => setClassroom(e.value)}
              optionLabel="label"
              placeholder="Choisir une Salle"
              className="w-full mb-3"
            />
          </div>
        </div>

        <label htmlFor="points" className="block text-900 font-medium mb-2">
          Points
        </label>
        <InputNumber
          id="points"
          value={points}
          onValueChange={(e) => setPoints(e.value ?? 0)}
          mode="decimal"
          minFractionDigits={0}
          maxFractionDigits={2}
          min={0}
          className="w-full mb-1"
        />
        <small className="text-600">
          Points attribués à cette séance (initialisés depuis la programmation).
        </small>
      </MeaUpdateModal>
    </>
  );
});

export default UpdateSessionModal;
